var React = require('react');

function Message (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.51015 15.4922V12.1816H2.2828C1.31582 12.1816 0.529297 11.3951 0.529297 10.4282V2.24561C0.529297 1.27872 1.31582 0.492188 2.2828 0.492188H13.7384C14.7052 0.492188 15.4917 1.27872 15.4917 2.24561V10.4282C15.4917 11.3951 14.7052 12.1816 13.7384 12.1816H6.82069L3.51015 15.4922ZM2.2828 1.66113C1.96035 1.66113 1.69824 1.92325 1.69824 2.24561V10.4282C1.69824 10.7505 1.96035 11.0126 2.2828 11.0126H4.67901V12.6701L6.33647 11.0126H13.7384C14.0607 11.0126 14.3229 10.7505 14.3229 10.4282V2.24561C14.3229 1.92325 14.0607 1.66113 13.7384 1.66113H2.2828ZM11.9849 3.41455H4.03612V4.5835H11.9849V3.41455ZM11.9849 5.75244H4.03612V6.92139H11.9849V5.75244ZM9.64701 8.09024H4.03612V9.25928H9.64701V8.09024Z","fill":"#04B3C0"}));
}

Message.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Message;

Message.default = Message;
